var _circle, _circle2, _circle3, _g, _circle4, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "url(#paint0_linear_428_12)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5005,
    cy: 55.5002,
    r: 43.3228,
    fill: "#705100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_12",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 17,
    width: 88,
    height: 87
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.1228,
    cy: 60.4395,
    r: 43.4236,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5008,
    cy: 55.5002,
    r: 43.4236,
    fill: "#E3A504"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0865,
    cy: 55.8118,
    r: 35.6734,
    fill: "#C18222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 34L63 48.3333L77 50.125L67.3867 61.1617L70 77L56 69.8333L42 77L44.6367 61.1617L35 50.125L49 48.3333L56 34Z",
    fill: "url(#paint1_linear_428_12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4493 33.7806L56 32.8606L55.5507 33.7806L48.6691 47.8716L34.9365 49.629L34.007 49.748L34.6234 50.4539L44.1047 61.3126L41.5068 76.9179L41.3437 77.8977L42.2278 77.4451L56 70.395L69.7722 77.4451L70.6547 77.8969L70.4933 76.9186L67.9183 61.3126L77.377 50.4534L77.9916 49.7478L77.0635 49.629L63.3309 47.8716L56.4493 33.7806Z",
    stroke: "#A36D1D",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_428_12",
    x1: 55.5,
    y1: 0,
    x2: 55.5,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD12D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_428_12",
    x1: 56,
    y1: 34,
    x2: 56,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE86D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bb81859a07de22e2cffac139aff486a0.svg";
export { ForwardRef as ReactComponent };